import { v4 } from 'uuid';

export const generateId = () => v4();
